<template>
  <div>
    <component
      v-for="(element, index) in content"
      :key="`content_element_${index}`"
      :is="getElementComponent(element)"
      :data="element"
    ></component>
  </div>
</template>

<script>
import { ContentEnums } from '@/enum/content.js';

import companyBenefits from './company-benefits.vue';
import htmlContent from './html-content.vue';
import companyDepartments from './company-departments.vue';
import expanderContent from './expander-content.vue';
import imageContent from './image-content.vue';
import testimonialItem from './testimonial-item.vue';

export default {
  name: 'inner-content-area',
  props: {
    content: {
      type: Array,
      required: true
    }
  },

  methods: {
    getElementComponent(contentElement) {
      if (
        contentElement.componentType ===
        ContentEnums.componentTypes.CompanyBenefits
      ) {
        return companyBenefits;
      }

      if (
        contentElement.componentType === ContentEnums.componentTypes.HtmlContent
      ) {
        return htmlContent;
      }

      if (
        contentElement.componentType ===
        ContentEnums.componentTypes.CompanyDepartments
      ) {
        return companyDepartments;
      }

      if (
        contentElement.componentType === ContentEnums.componentTypes.Expander
      ) {
        return expanderContent;
      }

      if (contentElement.componentType === ContentEnums.componentTypes.Image) {
        return imageContent;
      }

      if (
        contentElement.componentType ===
        ContentEnums.componentTypes.TestimonialItem
      ) {
        return testimonialItem;
      }

      return '';
    }
  }
};
</script>
